const UNLOCK_SCROLL = Symbol.for('UNLOCK_SCROLL');

export default UNLOCK_SCROLL;
